import {
  ASPECT_RATIO_LANDSCAPE,
  ASPECT_RATIO_PORTRAIT,
} from '@oneToOne/shared/components/chat/constants'
import { css } from 'twind/css'

export const visitorCameraPreviewContainer = (
  isMobilePortrait: boolean,
  height: number,
) =>
  css({
    width: '100%',
    backgroundColor: 'var(--gray-9)',
    aspectRatio: isMobilePortrait
      ? ASPECT_RATIO_PORTRAIT
      : ASPECT_RATIO_LANDSCAPE,
    maxHeight: isMobilePortrait && height ? `${height * 0.4}px` : '176px',
  })
